<template>
    <b-container fluid="md">
        <b-row align-h="between">
            <b-col md="auto" class="my-2">
                <b-input-group prepend="Filter">
                    <b-form-input v-model="filter" placeholder="Type to filter the table." />
                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">
                            Clear
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>

            <b-col v-if="isReviewer" md="auto" class="my-2">
                <b-button-group>
                    <b-button class="csv-button-text">
                        Download all inventories as CSV
                    </b-button>
                    <b-button id="csv-download-button"
                              v-b-tooltip.hover
                              title="Download a single CSV file containing all Inventories for all Institutions"
                              class="csv-download-button"
                              @click="downloadCsv"
                    >
                        <fa-icon
                            fixed-width
                            size="lg"
                            :icon="['fas', 'download']"
                        />
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-card no-body>
            <b-card-header class="inventories-list-header py-1">
                <span>Inventories by Institution</span>
            </b-card-header>
            <b-card-body>
                <applicantListTable
                    id="applicant-list-table"
                    :items="applicantListItems"
                    :filter="filter"
                    @row-clicked="viewApplicantInventory"
                />
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { alertManager as AlertManager } from '@/plugins/alertManager';

export default {
    name: 'Inventories',

    metaInfo() {
        return { title: 'Inventories by Applicant' };
    },

    data() {
        return {
            filter: null,
        };
    },

    computed: {
        ...mapGetters({
            isReviewer: 'auth/isReviewer',
            applications: 'application/applicationList',
            currentAy: 'ref/global/currentAy',
            applicantName: 'ref/ee/ficeName',
            ficeCodeShortName: 'ref/ee/ficeShortName',
        }),

        applicantListItems() {
            return this.applications.map((app) => {
                app.applicant_name = this.applicantName(app.applicant_id);
                return app;
            });
        },
    },

    created() {
        this.$store.dispatch('ref/ee/fetchRefEe', this.currentAy);
        this.$store.dispatch('application/fetchApplicationList');
    },

    methods: {
        viewApplicantInventory(item) {
            this.$router.push({
                name: 'inventory',
                params: {
                    lea: item.applicant_id,
                    currentAy: this.currentAy,
                },
            });
        },

        async downloadCsv(app) {
            try {
                const url = process.env.VUE_APP_API_URL + 'inventory/' + 'csv';
                await window.open(url, '_blank');

                AlertManager.showSuccess({ message: 'Successfully downloaded the CSV file.' });
            } catch (error) {
                AlertManager.showErr(error);
            }
        },
    },

};
</script>

<style lang="scss" scoped>
@import '$StyleVars';

.csv-button-text {
    color: #2c3e50;
    background-color: #e9ecef;
    cursor: default;
    border-color: #ced4da;
}

.csv-download-button {
    color: #2C6400;
    border-color: #2b64002c;
    background-color: #2b64002c;
    &:hover {
        color: white;
        background-color: #2C6400;
    }
}

.inventories-list-header {
    color: white;
    background-color: $ace-purple;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
}

</style>
